/**
 * @flow
 * @relayHash 9a17cea8f49d2a83cc36dbfde7966cd3
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ShopInfoQueryVariables = {|
  vendorID: string
|};
export type ShopInfoQueryResponse = {|
  +shop: ?{|
    +ref_id: string,
    +id: string,
    +name: ?string,
    +active: ?boolean,
    +policy: ?string,
    +about_vendor: ?string,
    +grouped_shipping_methods: ?$ReadOnlyArray<?{|
      +code: ?string,
      +title: ?string,
      +description: ?string,
    |}>,
    +shipping_methods: ?$ReadOnlyArray<?{|
      +formatted_shipping_method: ?{|
        +code: ?string,
        +title: ?string,
        +description: ?string,
      |},
      +ref_id: string,
    |}>,
    +payment_methods: $ReadOnlyArray<?{|
      +name: string,
      +code: ?string,
    |}>,
  |}
|};
export type ShopInfoQuery = {|
  variables: ShopInfoQueryVariables,
  response: ShopInfoQueryResponse,
|};
*/


/*
query ShopInfoQuery(
  $vendorID: ID!
) {
  shop(id: $vendorID) {
    ref_id
    id
    name
    active
    policy
    about_vendor
    grouped_shipping_methods {
      code
      title
      description
    }
    shipping_methods {
      formatted_shipping_method {
        code
        title
        description
      }
      ref_id
      id
    }
    payment_methods {
      name
      code
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "vendorID",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "vendorID",
    "type": "ID!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ref_id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "active",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "policy",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "about_vendor",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v9 = [
  v8,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  }
],
v10 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "grouped_shipping_methods",
  "storageKey": null,
  "args": null,
  "concreteType": "VendorGroupedShipmentResult",
  "plural": true,
  "selections": v9
},
v11 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "formatted_shipping_method",
  "storageKey": null,
  "args": null,
  "concreteType": "VendorGroupedShipmentResult",
  "plural": false,
  "selections": v9
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ShopInfoQuery",
  "id": null,
  "text": "query ShopInfoQuery(\n  $vendorID: ID!\n) {\n  shop(id: $vendorID) {\n    ref_id\n    id\n    name\n    active\n    policy\n    about_vendor\n    grouped_shipping_methods {\n      code\n      title\n      description\n    }\n    shipping_methods {\n      formatted_shipping_method {\n        code\n        title\n        description\n      }\n      ref_id\n      id\n    }\n    payment_methods {\n      name\n      code\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ShopInfoQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "shop",
        "storageKey": null,
        "args": v1,
        "concreteType": "Shop",
        "plural": false,
        "selections": [
          v2,
          v3,
          v4,
          v5,
          v6,
          v7,
          v10,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "shipping_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "VendorShippingMethod",
            "plural": true,
            "selections": [
              v11,
              v2
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "payment_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethod",
            "plural": true,
            "selections": [
              v4,
              v8
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ShopInfoQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "shop",
        "storageKey": null,
        "args": v1,
        "concreteType": "Shop",
        "plural": false,
        "selections": [
          v2,
          v3,
          v4,
          v5,
          v6,
          v7,
          v10,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "shipping_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "VendorShippingMethod",
            "plural": true,
            "selections": [
              v11,
              v2,
              v3
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "payment_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethod",
            "plural": true,
            "selections": [
              v4,
              v8,
              v3
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '14516b6fd48f037cca642061d89e73e5';
module.exports = node;
